<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pl-0">
          <h4 class="font-weight-regular primary--text">Estadísticas generales</h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-container fluid>
            <v-row justify="space-between">

              <!-- Número de empleados -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Número de empleados</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">45</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Nómina -->
              <v-col cols="2" class="text-center" style="position: relative">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Nómina</h5>
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3 class="font-weight-regular color-black">$203,078.00</h3>
                  </v-col>
                  <!-- <v-btn :to="{ name: 'paysheet' }" absolute right fab small style="right: -5px"><v-icon>mdi-chevron-right</v-icon></v-btn> -->
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- % Nómina -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">% Nómina</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">16 %</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- % Rotación -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">% Rotación</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">4 %</h3>
                  </v-col>
                </v-row>
              </v-col>

              <span class="vertical-divider"></span>

              <!-- Calificación interna -->
              <v-col cols="2" class="text-center">
                <v-row class="ma-0 fill-height" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                    <h5 class="font-weight-bold color-black">Calificación interna</h5>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h3 class="font-weight-regular color-black">8.8</h3>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
export default {
  name: 'hr-reports'
}
</script>
